import React, { useEffect, useState } from 'react';
import { Container, ListGroup, Navbar } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { NavLink } from 'reactstrap';

import NavbarUser from './NavbarUser';

import { useSelector } from 'react-redux';
import {
  UrlPath,
  ccaUserGroup,
  contractTypePrimary,
  csaUserGroup,
  endUserGroup,
  // FEATURE DISABLED (Release july-2026)
  // exhibitUserGroup,
  superUserGroup,
  viewerUserGroup,
} from '../../constants';
import LogoutButton from '../../pages/auth/LogoutButton';
import persistDataStore from '../../redux/persistStore';
import store from '../../redux/store';
// FEATURE DISABLED (Release july-2026)
// import AskAi from '../../sharedcomponents/askAi/AskAi';
// FEATURE DISABLED (Release july-2026) - home page removed
// import { ReactComponent as HomeIcon } from './../../assets/icons/common/home.svg';
import logo from './../../assets/img/logo/logo.svg';

const NavbarComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const groups = useSelector(
    (state) => state?.userInfo?.userInfo?.SPGGroups || [],
  );

  const isCCA = groups?.includes(ccaUserGroup);
  const isSuperUser = groups?.includes(superUserGroup);
  const isSUorCSAorViewer =
    groups?.includes(superUserGroup) ||
    groups?.includes(csaUserGroup) ||
    groups?.includes(viewerUserGroup);
  // FEATURE DISABLED (Release july-2026)
  const isExhibit = false; // was: groups?.includes(exhibitUserGroup)
  // only consider user as end user if they're not also a CCA user for navbar purposes
  const isEndUser =
    groups?.includes(endUserGroup) &&
    !isCCA &&
    !isExhibit &&
    !isSUorCSAorViewer;

  const [menu, setMenu] = useState([]);
  const [userName, setUserName] = useState('');
  const [isHovering, setIsHovering] = useState(false);
  const [userContractType, setUserContractType] = useState('');
  const [tlcLink, setTlcLink] = useState(null);

  // CSA gating data
  const csaActionData =
    persistDataStore.getState()?.userActionData?.csaUserActionInfo;
  const nonCSAPath = ['/user-location', '/entitlements', '/user-group'];

  // Keep user name from store
  useEffect(() => {
    const storeData = store.getState();
    const storeUserInfo = storeData?.userInfo;
    if (
      storeUserInfo?.userInfo &&
      userName !==
        `${storeUserInfo.userInfo.FirstName} ${storeUserInfo.userInfo.LastName}`
    ) {
      setUserName(
        `${storeUserInfo.userInfo.FirstName} ${storeUserInfo.userInfo.LastName}`,
      );
    }
    // eslint-disable-next-line
  }, [useSelector((x) => x.userInfo)]);

  // End user: contract type for Manage User IDs visibility
  useEffect(() => {
    const storeData = store.getState();
    const ct = storeData?.userContracts?.userContracts?.[0]?.contractType;
    if (ct) setUserContractType(ct);
    // eslint-disable-next-line
  }, [useSelector((x) => x.userContracts)]);

  // Get TLC_Link from dbConfig Redux state based on user group
  const tlcLinks = useSelector((state) => state?.dbConfig?.tlcLinks || []);
  useEffect(() => {
    if (tlcLinks && tlcLinks.length > 0 && groups && groups.length > 0) {
      // tlcLinks is an array of {key, value} objects
      // Find the matching link based on user group
      // Viewer and CSA users should use the same link as Super Users
      let linkUrl = null;

      if (isSUorCSAorViewer) {
        // Use super user link for Super Users, CSA, and Viewer groups
        const superUserLink = tlcLinks.find(
          (item) => item.key === superUserGroup,
        );
        if (superUserLink?.value) {
          linkUrl = superUserLink.value;
        }
      } else {
        // For other groups, find the matching link
        for (const group of groups) {
          const matchingLink = tlcLinks.find((item) => item.key === group);
          if (matchingLink?.value) {
            linkUrl = matchingLink.value;
            break;
          }
        }
      }
      setTlcLink(linkUrl);
    }
  }, [tlcLinks, groups]);

  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);

  // Build menu based on role
  useEffect(() => {
    if (isEndUser) {
      setMenu([
        // FEATURE DISABLED (Release july-2026) - home page removed
        // {
        //   name: <HomeIcon />,
        //   key: 0,
        //   keyName: '',
        //   to: UrlPath.home,
        //   tag: Link,
        //   path: [UrlPath.home],
        // },
        {
          name: 'My Subscription',
          key: 1,
          keyName: '',
          to: UrlPath.mySubscription,
          tag: Link,
          path: [UrlPath.mySubscription],
        },
        {
          name: 'Packages & Delivery',
          key: 2,
          keyName: '',
          to: UrlPath.packages,
          tag: Link,
          path: [
            UrlPath.packages,
            '/packages/package-details',
            '/packages/delivery-platform-details',
          ],
        },
        {
          name: userName,
          key: 3,
          keyName: 'username',
          to: '/user-info',
          tag: Link,
          path: ['/user-info'],
        },
      ]);
    } else if (isSUorCSAorViewer) {
      setMenu([
        {
          name: 'Home',
          key: 1,
          keyName: '',
          to: UrlPath.adminDashboard,
          tag: Link,
          path: [UrlPath.adminDashboard],
        },
        {
          name: 'Users & Locations',
          key: 2,
          keyName: '',
          to: UrlPath.userLocation,
          tag: Link,
          path: [UrlPath.userLocation, UrlPath.exportUsers],
        },
        {
          name: 'My Groups',
          key: 3,
          keyName: '',
          to: UrlPath.userGroup,
          tag: Link,
          path: [UrlPath.userGroup],
        },
        {
          name: 'Entitlements',
          key: 4,
          keyName: '',
          to: UrlPath.entitlements,
          tag: Link,
          path: [
            UrlPath.entitlements,
            UrlPath.deleteEntitlements,
            UrlPath.addEntitlements,
            UrlPath.exportEntitlements,
            UrlPath.productEntitlements,
          ],
        },
        {
          name: 'Packages & Delivery',
          key: 5,
          keyName: '',
          to: UrlPath.packages,
          tag: Link,
          path: [
            UrlPath.packages,
            '/packages/package-details',
            '/packages/delivery-platform-details',
          ],
        },
        { name: userName, key: 6, keyName: 'username' },
      ]);
    } else if (isExhibit) {
      // Exhibit: only Users & Locations and Entitlements
      setMenu([
        {
          name: 'Users & Locations',
          key: 1,
          keyName: '',
          to: UrlPath.userLocation,
          tag: Link,
          path: [UrlPath.userLocation, UrlPath.exportUsers],
        },
        {
          name: 'Entitlements',
          key: 2,
          keyName: '',
          to: UrlPath.entitlements,
          tag: Link,
          path: [
            UrlPath.entitlements,
            UrlPath.deleteEntitlements,
            UrlPath.addEntitlements,
            UrlPath.exportEntitlements,
            UrlPath.productEntitlements,
          ],
        },
        { name: userName, key: 3, keyName: 'username' },
      ]);
    } else {
      // CCA or default
      setMenu([
        // FEATURE DISABLED (Release july-2026) - home page removed
        // {
        //   name: <HomeIcon />,
        //   key: 0,
        //   keyName: '',
        //   to: UrlPath.home,
        //   tag: Link,
        //   path: [UrlPath.home],
        // },
        {
          name: 'Users & Locations',
          key: 1,
          keyName: '',
          to: UrlPath.userLocation,
          tag: Link,
          path: [UrlPath.userLocation, UrlPath.exportUsers],
        },
        {
          name: 'My Groups',
          key: 2,
          keyName: '',
          to: UrlPath.userGroup,
          tag: Link,
          path: [UrlPath.userGroup],
        },
        {
          name: 'Entitlements',
          key: 3,
          keyName: '',
          to: UrlPath.entitlements,
          tag: Link,
          path: [
            UrlPath.entitlements,
            UrlPath.deleteEntitlements,
            UrlPath.addEntitlements,
            UrlPath.exportEntitlements,
            UrlPath.productEntitlements,
          ],
        },
        {
          name: 'Packages & Delivery',
          key: 4,
          keyName: '',
          to: UrlPath.packages,
          tag: Link,
          path: [
            UrlPath.packages,
            '/packages/package-details',
            '/packages/delivery-platform-details',
          ],
        },
        {
          name: userName,
          key: 5,
          keyName: 'username',
          to: UrlPath.userDashboard,
          tag: Link,
          path: [UrlPath.userDashboard],
        },
      ]);
    }
  }, [userName, isEndUser, isSUorCSAorViewer, isExhibit, isCCA]);

  // FEATURE DISABLED (Release july-2026)
  // const isSelectionScreen =
  //   location.pathname === UrlPath.accountTypeSelection;
  const isSelectionScreen = false;

  const onChangeHistoryClick = () => navigate(UrlPath.changeHistory);
  const onReportsClick = () => navigate(UrlPath.reports);
  const onManageEmailDomainsClick = () =>
    navigate(UrlPath.emailDomainContractSettings);
  // FEATURE DISABLED (Release july-2026)
  // const onUsageAnalysisClick = () => navigate(UrlPath.usageAnalysis);
  const onAnalyticsDashboardClick = () => navigate(UrlPath.analyticsDashboard);
  const onManageUserIDsClick = () => navigate(UrlPath.manageUserIDs);

  const onCloseMenuItem = (id) => {
    const disableHeaderFocus = !!window.sessionStorage.disableHeaderFocus;
    if (!disableHeaderFocus && id === window.sessionStorage.modalName) {
      const el = document.querySelector('#askAiHeaderBtnIcon');
      if (el) el.focus();
    }
  };

  const getMenuClassName = (m) => {
    if (isSUorCSAorViewer) {
      if (
        nonCSAPath.includes(m.to) &&
        (!csaActionData?.type || location.pathname === UrlPath.adminDashboard)
      ) {
        return 'menu-disable';
      }
    }
    return m.path?.some((p) => location.pathname.includes(p)) ? 'active' : '';
  };

  // Determine safe base path (only uses hardcoded constants, no user input)
  const getBrandPath = () => {
    if (isEndUser) return UrlPath.mySubscription;
    if (isSUorCSAorViewer) return UrlPath.adminDashboard;
    if (isExhibit) return UrlPath.userLocation;
    return UrlPath.packages;
  };

  return (
    <Navbar variant="light" expand="lg" className="navbar-bg" sticky="top">
      <Container fluid className="mx-lg-1">
        <div className="logo-section">
          <a className="navbar-brand" href={getBrandPath()}>
            <img src={logo} className="img-fluid me-1 logo-img" alt="Admin" />
          </a>
          <span className="logo-sub-heading">Subscription Manager</span>
        </div>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {/* FEATURE DISABLED (Release july-2026) */}
            {/* {!isSelectionScreen && (
              <li className="nav-item" key={-1}>
                <NavLink>
                  <AskAi
                    navIconId="askAiHeaderBtnIcon"
                    onCloseMenuItem={onCloseMenuItem}
                  />
                </NavLink>
              </li>
            )} */}
            {menu
              .filter((m) => !isSelectionScreen || m.keyName === 'username')
              .map((m, idx) => (
                <React.Fragment key={m.key}>
                <li className="nav-item">
                  {m.keyName !== 'username' ? (
                    <NavLink
                      tag={m.tag}
                      key={m.key}
                      className={getMenuClassName(m)}
                      to={m.to}
                    >
                      {m.name}
                    </NavLink>
                  ) : (
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <NavbarUser
                        name={m.name}
                        navLinkData={
                          // For CSA/Viewer and Exhibit users, render a non-link element to avoid URL changes
                          isSUorCSAorViewer || isExhibit
                            ? {
                                tag: 'div',
                                key: m.key,
                                className: m.path?.includes(location.pathname)
                                  ? 'active'
                                  : '',
                              }
                            : {
                                tag: Link,
                                key: m.key,
                                className: m.path?.includes(location.pathname)
                                  ? 'active'
                                  : '',
                                to: m.to,
                              }
                        }
                      />
                      {isHovering && (
                        <div className="position-absolute">
                          <ListGroup className="position-fixed option-list">
                            {isSUorCSAorViewer ? (
                              <>
                                {(isSuperUser ||
                                  groups?.includes(csaUserGroup)) && (
                                  <ListGroup.Item className="option-list-item">
                                    <div
                                      className="cursor-pointer"
                                      onClick={onAnalyticsDashboardClick}
                                    >
                                      Analytics Dashboard
                                    </div>
                                  </ListGroup.Item>
                                )}
                                <ListGroup.Item className="option-list-item">
                                  <div
                                    className="cursor-pointer"
                                    onClick={onReportsClick}
                                  >
                                    Active Users Export
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item className="option-list-item">
                                  <div
                                    id="history_option"
                                    className="cursor-pointer"
                                    onClick={onChangeHistoryClick}
                                  >
                                    Change History
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item className="option-list-item">
                                  <div
                                    className="cursor-pointer"
                                    onClick={onManageEmailDomainsClick}
                                  >
                                    Contract Settings
                                  </div>
                                </ListGroup.Item>
                                {tlcLink && (
                                  <ListGroup.Item className="option-list-item">
                                    <a
                                      href={tlcLink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="cursor-pointer"
                                    >
                                      Learning Center
                                    </a>
                                  </ListGroup.Item>
                                )}
                                {/* FEATURE DISABLED (Release july-2026) */}
                                {/* <ListGroup.Item className="option-list-item">
                                  <div
                                    className="cursor-pointer"
                                    onClick={onUsageAnalysisClick}
                                  >
                                    Usage Analysis
                                  </div>
                                </ListGroup.Item> */}
                                <ListGroup.Item className="option-list-item">
                                  <LogoutButton />
                                </ListGroup.Item>
                              </>
                            ) : isEndUser ? (
                              <>
                                {userContractType !== contractTypePrimary && (
                                  <ListGroup.Item className="option-list-item">
                                    <div
                                      id="manage_user_ids_option"
                                      className="cursor-pointer"
                                      onClick={onManageUserIDsClick}
                                    >
                                      Manage User IDs
                                    </div>
                                  </ListGroup.Item>
                                )}
                                <ListGroup.Item className="option-list-item">
                                  <LogoutButton />
                                </ListGroup.Item>
                              </>
                            ) : isExhibit ? (
                              <>
                                <ListGroup.Item className="option-list-item">
                                  <LogoutButton />
                                </ListGroup.Item>
                              </>
                            ) : (
                              <>
                                <ListGroup.Item className="option-list-item">
                                  <div
                                    className="cursor-pointer"
                                    onClick={onReportsClick}
                                  >
                                    Active Users Export
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item className="option-list-item">
                                  <div
                                    id="history_option"
                                    className="cursor-pointer"
                                    onClick={onChangeHistoryClick}
                                  >
                                    Change History
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item className="option-list-item">
                                  <LogoutButton />
                                </ListGroup.Item>
                              </>
                            )}
                          </ListGroup>
                        </div>
                      )}
                    </div>
                  )}
                </li>
                </React.Fragment>
              ))}
          </ul>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
